import { useTabsContext } from './Tabs'
import type { PanelProps } from './types'

export const Panel: React.FC<React.PropsWithChildren<PanelProps>> = ({
  index,
  children,
}) => {
  const { activeTab, id } = useTabsContext()

  const baseId = `${id}-tab[${index}]`

  return (
    <div
      aria-labelledby={`${baseId}-button`}
      className={activeTab !== index ? 'hidden' : undefined}
      id={`${baseId}-panel`}
      role="tabpanel"
      tabIndex={0}
    >
      {children}
    </div>
  )
}
